import React from "react";
import { Card, CardMedia, CardContent, CardActions, Typography, IconButton, Box, } from "@mui/material";
import { AddShoppingCart } from "@mui/icons-material";
import DOMPurify from "dompurify";
import styles from "./styles";
import { useCartContext } from "@/hooks/useCartContext";
var Product = function (_a) {
    var product = _a.product;
    var onAddToCart = useCartContext().onAddToCart;
    var data = product.description;
    var sanitizedData = function () { return ({
        __html: DOMPurify.sanitize(data),
    }); };
    return (React.createElement(Card, { sx: styles.root },
        React.createElement(CardMedia, { sx: styles.media, image: product.image.url, title: product.name }),
        React.createElement(CardContent, null,
            React.createElement(Box, { sx: styles.cardContent },
                React.createElement(Typography, { variant: "h5", gutterBottom: true }, product.name),
                React.createElement(Typography, { variant: "h5", gutterBottom: true }, product.price.formatted_with_symbol)),
            React.createElement(Typography, { dangerouslySetInnerHTML: sanitizedData(), variant: "body2", color: "textSecondary" })),
        React.createElement(CardActions, { disableSpacing: true, sx: styles.cardActions },
            React.createElement(IconButton, { "aria-label": "Add To Cart", onClick: function () { return onAddToCart(product.id, 1); }, size: "large" },
                React.createElement(AddShoppingCart, null)))));
};
export default Product;
